import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";
import SEO from "../../common-components/SEO";

export const Achievements = () => {
  useEffect(() => {
    AOS.init();
  }, []);

  const achievements = [
    // {
    //   id: 1,
    //   title: "MOU with CEPT University",
    //   year: "2021",
    //   image: "assets/images/achievements/1_1.webp",
    //   description: "On February 27, 2021, CEPT University signed an MoU with McGan's Ooty School of Architecture for a mentorship program aligned with India's New Education Policy. The agreement, overseen by Chief Guest Smt. Anju Sharma, Principal Secretary for Higher Education, marks a significant collaboration aimed at enhancing architectural education. CEPT University, established in 1962 alongside NID and IIM Ahmedabad, is renowned globally for its contributions to education, research, and advisory work in habitat disciplines. This partnership opens new opportunities for academic growth and innovation at McGan's.",
    //   category: "Partnership",
    //   icon: "ri-handshake-line"
    // },
     {
      id: 1,
      title: "Outlook I CARE Rankings 2025",
      subtitle: "1st in Tamil Nadu, 8th in India",
      year: "2025",
      image: "assets/images/achievements/6.webp",
      description: "McGan's Ooty School of Architecture has been ranked 1st in Tamil Nadu and 8th in India in the Outlook I-Care Rankings 2025, a testament to our excellence in architectural education and innovation.",
      category: "Ranking",
      icon: "ri-medal-line"
    },
     {
      id: 2,
      title: "Outlook I CARE Rankings 2024",
      subtitle: "1st in Tamil Nadu, 9th in India",
      year: "2024",
      image: "assets/images/achievements/5.webp",
      description: "McGan's Ooty School of Architecture has been proudly ranked 1st in Tamil Nadu and 9th in India in the Outlook I-Care Rankings 2024, recognizing our commitment to excellence in architectural education.",
      category: "Ranking",
      icon: "ri-medal-line"
    },
   
    {
      id: 3,
      title: "McGans World Record Event 2023",
      subtitle: "160 Artists, 160 Paintings, 160 Meters, 120 Minutes",
      year: "2023",
      image: "assets/images/achievements/2.webp",
      description: "The McGANS World Record Event 2023 brought together 160 talented artists who set a world record by creating breathtaking paintings of India's famous tourist spots in just 2 hours. Displayed on a massive 160-meter canvas, these stunning artworks captured the essence of India's diverse landscapes. The event gained widespread acclaim, earning a place in the prestigious India Book of Records and international recognition.",
      category: "World Record",
      icon: "ri-trophy-line"
      
    },
    // {
    //   id: 3,
    //   title: "A Glimpse of MOU sign up with Ethos Foundation",
    //   year: "2024",
    //   image: "assets/images/achievements/1.webp",
    //   description: "A proud moment for McGan’s! An MoU was signed with Ethos Foundation to strengthen design education, enhance student opportunities, and foster industry-academia partnerships",
    //   category: "Partnership",
    //   icon: "ri-award-line"
    // },
    {
      id: 4,
      title: "NASA Ranked - LE CORBUSIER TROPHY",
      subtitle: "67th Year - Ranked 19th in India",
      year: "2024",
      image: "assets/images/achievements/3.webp",
      description: "National association of students of Architecture—A moment of pride for McGAN'S Ooty School of Architecture—Ranked 19th in India! We continue our commitment to fostering the next generation of architects.",
      category: "Ranking",
      icon: "ri-award-line"
    },
    {
      id: 5,
      title: "India's Best Design Student 2024",
      year: "2024",
      image: "assets/images/achievements/4.webp",
      description: "Mr. Antony Weslee Babu has been recognised as the winner of INDIA'S BEST DESIGN STUDENTS- 2024 among the best architecture colleges by India's Best Design Award",
      category: "Student Achievement",
      icon: "ri-star-line"
    },
   
    {
      id: 8,
      title: "200 Artists Meet",
      year: "2025",
      image: "assets/images/achievements/7.webp",
      description: "On February 6, McGan's proudly hosted a grand meet of 200 artists, bringing together creativity, talent, and inspiration. The event fostered collaboration, celebrated artistic excellence, and provided a platform for artists to connect, share ideas, and showcase their passion for art.",
      category: "Event",
      icon: "ri-palette-line"
    },
    {
      id: 9,
      title: "CM Trophy Swimming Championships",
      year: "2025",
      image: "assets/images/achievements/8.webp",
      description: "Victory at CM Trophy – Swimming! Proud moment for our 2nd year champs at the CM Trophy, held at Lawrence School, Lovedale!",
      highlights: ["🥇 Mohammed Fayaz - 1st Place: 50m Freestyle; 100m Backstroke", "🥉 Kyathi Golchha - 3rd Place: 50m Freestyle; 100m Freestyle"],
      category: "Sports",
      icon: "ri-basketball-line"
    }
  ];

  return (
    <>
      {/* Add SEO Tags */}
      <SEO
        fullTitle={"Achievements — McGAN'S Ooty School of Architecture | Rankings, Awards & Events"}
        description={"Discover McGAN'S notable achievements: national rankings, world‑record events, student awards and strategic partnerships (highlights from 2023–2025)."}
        keywords={`Achievements, McGAN'S, architecture awards, Outlook I CARE rankings, NASA trophy, India design awards, architecture events in Ooty, student achievements, world record event`}
        image={"https://mcgansarch.com/assets/images/achievements/6.webp"}
        url={"https://mcgansarch.com/achievements"}
      />

      <h1 style={{ display: "none" }}>
        Remarkable Milestones of McGAN'S Ooty School of Architecture
      </h1>

      {/* Page Banner Area */}
      <div className="page-banner-area bg-2">
        <div className="container">
          <div className="page-banner-content">
            <h3 className="BannerHeader">Our Achievements</h3>
            <ul>
              <li>
                <Link to="/">Home</Link>
              </li>
              <li className="navspace">Achievements</li>
            </ul>
          </div>
        </div>
      </div>
      {/* End Page Banner */}

      {/* Start Achievements Grid Section */}
      <div className="achievements-grid-area pt-100 pb-100">
        <div className="container">
          <div className="section-title text-center mb-5">
            <h2>Our Achievements</h2>
            <p>Celebrating excellence and milestones in architectural education</p>
          </div>
          
          <div className="row">
            {achievements.map((achievement, index) => (
              <div key={achievement.id} className="col-lg-4 col-md-6 mb-4" 
                   data-aos="fade-up" 
                   data-aos-delay={index * 100}>
                <div className="achievement-card">
                  <div className="achievement-image">
                    <img 
                      src={achievement.image} 
                      alt={achievement.title}
                      width={178} height={125}
                      className="img-fluid"
                    />
                  </div>
                  
                  <div className="achievement-content">
                    <h4 className="achievement-title">{achievement.title}</h4>
                    {achievement.subtitle && (
                      <h6 className="achievement-subtitle">{achievement.subtitle}</h6>
                    )}
                    <p className="achievement-description">{achievement.description}</p>
                    
                    {achievement.highlights && (
                      <div className="achievement-highlights">
                        <h6>Highlights:</h6>
                        <ul>
                          {achievement.highlights.map((highlight, idx) => (
                            <li key={idx}>{highlight}</li>
                          ))}
                        </ul>
                      </div>
                    )}
                    
                    <div className="achievement-footer">
                      <span className="achievement-badge">{achievement.category}</span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* End Achievements Grid Section */}

      {/* Custom CSS */}
      <style jsx>{`
        .achievements-grid-area {
          background: #f8f9fa;
        }
        
        .achievement-card {
          background: #fff;
          border-radius: 20px;
          overflow: hidden;
          box-shadow: 0 10px 30px rgba(0,0,0,0.1);
          transition: all 0.3s ease;
          height: 100%;
          display: flex;
          flex-direction: column;
        }
        
        .achievement-card:hover {
          transform: translateY(-10px);
          box-shadow: 0 20px 50px rgba(178, 13, 18, 0.3);
        }
        
        .achievement-image {
          position: relative;
          height: 250px;
          overflow: hidden;
        }
        
        .achievement-image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          transition: all 0.3s ease;
          filter: brightness(1);
        }
        
        .achievement-card:hover .achievement-image img {
          transform: scale(1.05);
          filter: brightness(0.8);
        }
        
        .achievement-content {
          padding: 25px;
          flex-grow: 1;
          display: flex;
          flex-direction: column;
        }
        
        .achievement-title {
          color: #333;
          font-size: 18px;
          font-weight: bold;
          margin-bottom: 10px;
          line-height: 1.4;
        }
        
        .achievement-subtitle {
          color: #b20d12;
          font-size: 14px;
          font-weight: 600;
          margin-bottom: 15px;
        }
        
        .achievement-description {
          color: #666;
          font-size: 14px;
          line-height: 1.6;
          margin-bottom: 20px;
          flex-grow: 1;
          display: -webkit-box;
          -webkit-line-clamp: 4;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
        
        .achievement-highlights {
          background: #f8f9fa;
          padding: 15px;
          border-radius: 10px;
          margin-bottom: 20px;
        }
        
        .achievement-highlights h6 {
          color: #b20d12;
          font-size: 12px;
          font-weight: bold;
          margin-bottom: 10px;
          text-transform: uppercase;
        }
        
        .achievement-highlights ul {
          margin: 0;
          padding-left: 15px;
        }
        
        .achievement-highlights li {
          font-size: 12px;
          color: #666;
          margin-bottom: 5px;
        }
        
        .achievement-footer {
          margin-top: auto;
        }
        
        .achievement-badge {
          background: linear-gradient(135deg, #b20d12, #8a0a0f);
          color: white;
          padding: 6px 12px;
          border-radius: 15px;
          font-size: 11px;
          font-weight: bold;
          text-transform: uppercase;
          letter-spacing: 0.5px;
        }
        
        @media (max-width: 768px) {
          .achievement-image {
            height: 200px;
          }
          
          .achievement-content {
            padding: 20px;
          }
          
          .achievement-title {
            font-size: 16px;
          }
          
          .achievement-description {
            -webkit-line-clamp: 3;
          }
        }
      `}</style>
    </>
  );
};